<template>
  <Transition name="app-update">
    <div
      v-if="updateAvailable"
      class="fixed inset-x-0 bottom-0 z-50 flex justify-center px-4 pb-4 pointer-events-none"
      role="status"
    >
      <div class="pointer-events-auto flex items-center gap-3 rounded-lg bg-gray-900 dark:bg-gray-800 text-white shadow-lg ring-1 ring-white/10 px-4 py-3 text-sm">
        <span>{{ t('common.appUpdate.message') }}</span>
        <button
          type="button"
          class="shrink-0 inline-flex items-center rounded-md bg-teal-500 hover:bg-teal-400 px-3 py-1 font-medium text-white"
          @click="reload"
        >
          {{ t('common.appUpdate.reload') }}
        </button>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
const { t } = useI18n()
const updateAvailable = ref(false)

// Nuxt periodically re-fetches the build manifest (checkOutdatedBuildInterval)
// and fires `app:manifest:update` on the client when a newer deploy is live.
const nuxtApp = useNuxtApp()
const off = nuxtApp.hook('app:manifest:update', () => {
  updateAvailable.value = true
})
onBeforeUnmount(off)

function reload() {
  reloadNuxtApp({ force: true })
}
</script>

<style scoped>
.app-update-enter-active,
.app-update-leave-active {
  transition: transform 0.2s ease, opacity 0.2s ease;
}
.app-update-enter-from,
.app-update-leave-to {
  transform: translateY(1rem);
  opacity: 0;
}
</style>
